import { render, staticRenderFns } from "./ModuleHeader.vue?vue&type=template&id=b344ae5a"
import script from "./ModuleHeader.vue?vue&type=script&lang=ts"
export * from "./ModuleHeader.vue?vue&type=script&lang=ts"
import style0 from "./ModuleHeader.vue?vue&type=style&index=0&id=b344ae5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports